import React from "react";
import { Icon, Message } from "semantic-ui-react";

const DisponibilidadOperacionesMessage = () => {
  return (
    <>
      <Message attached="bottom" size="small" color="blue">
        <Icon name="warning circle" />
        Esta operación sólo se puede realizar hasta las 8:00pm.
      </Message>
    </>
  );
};

export default DisponibilidadOperacionesMessage;
